module.exports = __webpack_public_path__ + "static/media/solutions.be6ed942.svg";